import { createAction, props } from '@ngrx/store';

import { CropAid, ProprietaryFertilizerData } from '../models/proprietary-fertilizer.model';

export const fetchOriginalCropAids = createAction('[App] Fetch original crop aids');

export const fetchProprietaryFertilizers = createAction('[App] Fetch proprietary fertilizers');

export const setOriginalCropAids = createAction(
  '[App] Set original crop aids',
  props<{ cropAids: CropAid[] }>(),
);

export const setProprietaryFertilizers = createAction(
  '[App] Set proprietary fertilizers',
  props<{ proprietaryFertilizers: CropAid[] }>(),
);

export const upsertProprietaryFertilizer = createAction(
  '[App] Upsert proprietary fertilizer',
  props<{ proprietaryFertilizer: ProprietaryFertilizerData }>(),
);

export const openProprietaryFertilizerDialog = createAction(
  '[App] Open proprietary fertilizer dialog',
  props<{ proprietaryFertilizer: ProprietaryFertilizerData }>(),
);
